import { Link } from '@tanstack/react-router';
import { ChatNote, type ChatAuthor } from '@wundo/ui';
import { findingClassLabel } from '@/components/conversationReview/findingClasses.ts';
import { ATTENTION_TONES } from '@/components/conversationReview/needsAttention.ts';
import { SEVERITY_LABELS } from '@/components/conversationReview/severity.ts';
import type { PlacedFinding } from './placeFindings.ts';

export interface FindingNoteProps {
  placed: PlacedFinding;
  author: ChatAuthor;
  /** The finding the findings bar is on. */
  current?: boolean;
  className?: string;
}

/** What the reviewer found about one message, under that message, with the way to the review. */
export function FindingNote({ placed, author, current, className }: FindingNoteProps) {
  const { finding } = placed;

  return (
    <ChatNote
      data-finding={placed.key}
      data-current={current || undefined}
      author={author}
      tone={ATTENTION_TONES[finding.severity]}
      label={findingClassLabel(finding.class)}
      title={SEVERITY_LABELS[finding.severity]}
      className={className}
    >
      {finding.description}{' '}
      <Link
        to='/conversation-reviews/$id'
        params={{ id: placed.reviewId }}
        className='font-semibold whitespace-nowrap text-ink underline underline-offset-2 hover:text-ink-secondary'
      >
        Open review
      </Link>
    </ChatNote>
  );
}
